import React, { useState } from "react";
import { Dropzone, FileItem, FullScreenPreview } from "@dropzone-ui/react";

const MAX_FILE_SIZE = 1024 * 1024 * 10;

function Uploader({ files, handleDeleteFile, handleFilesChange }) {
  /*   const [files, setFiles] = useState([]); */
  const [selectedImage, setSelectedImage] = useState(null);

  const validator = (file) => {
    return {
      valid: file.size <= MAX_FILE_SIZE,
      errors: [],
    };
  };

  const handleCloseFullScreenPreview = () => {
    setSelectedImage(null);
  };

  const handleOnSeeFile = (srcImg) => {
    setSelectedImage(srcImg);
  };

  return (
    <>
      <Dropzone
        value={files}
        onChange={handleFilesChange}
        localization="ES-es"
        label="Arrastrar o hacer click"
        maxFiles={1}
        header
        footer={false}
        accept=" 
        .jpg,
        .jpeg,
        .png,
        .webp,
        .pdf,
        .doc,
        .docx,
        .xls,
        .xlsx,
        .ppt,
        .pptx,
        .ods,
        .odp,
        .odt,
        .txt"
        view="grid"
        removeOnDrop={true}
        validator={validator}
        maxHeight="220px"
        minHeight="220px"
      >
        {files.map((file) => (
          <FileItem
            {...file}
            preview
            onSee={handleOnSeeFile}
            onDelete={handleDeleteFile}
            localization="ES-es"
            key={file.id}
            hd
          />
        ))}
      </Dropzone>

      <FullScreenPreview
        imgSource={selectedImage}
        openImage={selectedImage}
        onClose={handleCloseFullScreenPreview}
      />

      {/*       <div>
        <img src={imagePreview} width="400" />
        <input type="file" onChange={handleFileChange} />
      </div> */}
    </>
  );
}

export default Uploader;
